export default __webpack_public_path__ + "static/media/hlp_adaclub_arma_tempo.ac179219.jpg";